<table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="qualifier">
        <th mat-header-cell class="w-1/3" *matHeaderCellDef>Qualifier</th>
        <td mat-cell
            *matCellDef="let qualifierValue"
        >
            <div class="cell-no-wrap" [matTooltip]="qualifierValue.qualifierLabel" tooltipIfClamped>
                <strong>{{qualifierValue.qualifierLabel}}</strong>
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="requirement">
        <th mat-header-cell class="w-1/3" *matHeaderCellDef>Requirement</th>
        <td mat-cell
            *matCellDef="let qualifierValue"
        >
            <div class="cell-no-wrap" [matTooltip]="qualifierValue.requirementLabel" tooltipIfClamped>
                {{qualifierValue.requirementLabel}}
            </div>
        </td>
    </ng-container>
    <ng-container matColumnDef="actual">
        <th mat-header-cell class="w-1/3" *matHeaderCellDef>Actual</th>
        <td mat-cell
            *matCellDef="let qualifierValue"
        >
            <div class="grid grid-flow-col items-center gap-2 grid-cols-[auto_auto_1fr]">
                <mat-icon [ngClass]="{
                    'text-green-600': qualifierValue.status === 'accepted',
                    'text-red-500': qualifierValue.status === 'rejected',
                }">
                    fiber_manual_record
                </mat-icon>
                <span class="leading-none">{{qualifierValue.actualValue}}</span>
                <span class="justify-self-end">
                    <ng-container *ngIf="qualifierValue.actualValue && qualifierValue.actualValue !== 'Missing' && qualifierValue.fromVerifiedSource">
                        <mat-icon [matTooltip]="'Verified by: ' + qualifierValue.verifiedSourceLabel + ' on ' + qualifierValue.verifiedSourceDate" [color]="'primary'">verified</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="!qualifierValue.sourcesMatch && qualifierValue.verifiedSourceLabel !== 'N/A'">
                        <mat-icon class="material-symbols-outlined" [matTooltip]="'This data was not provided by ' + qualifierValue.verifiedSourceLabel + ' and therefore disqualified the customer.'">info</mat-icon>
                    </ng-container>
                </span>
            </div>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
